module.exports = __webpack_public_path__ + "img/cadenas.8108868b.png";